import { faStripeS } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getIconSize } from "../bcp/BCPIcons";

export function StripeIcon(props) {
  const { sx, style, outlined, size, ...rest } = props;

  const iconSize = getIconSize(size);

  return (
    <FontAwesomeIcon
      icon={faStripeS}
      style={{
        fontSize: iconSize,
        width: iconSize,
        ...style,
        ...sx,
      }}
      {...rest}
    />
  );
}
